import { __assign, __generator, __values } from "tslib";
import { Children } from 'react';
import { CacheableList } from './CacheableList';
import { isCollectionElement } from './utils';
var CollectionBuilder = /** @class */ (function () {
    function CollectionBuilder() {
    }
    CollectionBuilder.prototype.build = function (props) {
        var children = props.children;
        var builder = this;
        return new CacheableList(function () {
            var items, index, items_1, items_1_1, element, nodes, nodes_1, nodes_1_1, node, e_1_1, e_2_1;
            var e_2, _a, e_1, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        items = [];
                        Children.forEach(children, function (child) {
                            items.push(child);
                        });
                        index = 0;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 12, 13, 14]);
                        items_1 = __values(items), items_1_1 = items_1.next();
                        _c.label = 2;
                    case 2:
                        if (!!items_1_1.done) return [3 /*break*/, 11];
                        element = items_1_1.value;
                        nodes = builder.getNodes({ element: element }, index);
                        _c.label = 3;
                    case 3:
                        _c.trys.push([3, 8, 9, 10]);
                        nodes_1 = (e_1 = void 0, __values(nodes)), nodes_1_1 = nodes_1.next();
                        _c.label = 4;
                    case 4:
                        if (!!nodes_1_1.done) return [3 /*break*/, 7];
                        node = nodes_1_1.value;
                        return [4 /*yield*/, node];
                    case 5:
                        _c.sent();
                        index++;
                        _c.label = 6;
                    case 6:
                        nodes_1_1 = nodes_1.next();
                        return [3 /*break*/, 4];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_1_1 = _c.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (nodes_1_1 && !nodes_1_1.done && (_b = nodes_1.return)) _b.call(nodes_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 10:
                        items_1_1 = items_1.next();
                        return [3 /*break*/, 2];
                    case 11: return [3 /*break*/, 14];
                    case 12:
                        e_2_1 = _c.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 14];
                    case 13:
                        try {
                            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    CollectionBuilder.prototype.getNodes = function (item, index, parent) {
        var element, node, nodes, nodes_2, nodes_2_1, node, nodeKey, partialNodes, partialNodes_1, partialNodes_1_1, partialNode, e_3_1, e_4_1;
        var e_4, _a, e_3, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    element = this.getCollectionElement(item);
                    if (!!element) return [3 /*break*/, 3];
                    node = this.createNode(item);
                    if (!node) return [3 /*break*/, 2];
                    return [4 /*yield*/, node];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2: return [2 /*return*/];
                case 3:
                    nodes = element.type.getCollectionNode(element.props);
                    _c.label = 4;
                case 4:
                    _c.trys.push([4, 15, 16, 17]);
                    nodes_2 = __values(nodes), nodes_2_1 = nodes_2.next();
                    _c.label = 5;
                case 5:
                    if (!!nodes_2_1.done) return [3 /*break*/, 14];
                    node = nodes_2_1.value;
                    nodeKey = this.getKey(element, node, index, parent);
                    partialNodes = this.getNodes(__assign(__assign({}, node), { key: nodeKey }), index, parent);
                    _c.label = 6;
                case 6:
                    _c.trys.push([6, 11, 12, 13]);
                    partialNodes_1 = (e_3 = void 0, __values(partialNodes)), partialNodes_1_1 = partialNodes_1.next();
                    _c.label = 7;
                case 7:
                    if (!!partialNodes_1_1.done) return [3 /*break*/, 10];
                    partialNode = partialNodes_1_1.value;
                    // TODO: Возможно стоит выкидывать ошибку в дев режиме
                    if (item.type && item.type !== partialNode.type) {
                        throw new Error("Invalid node type. Expected: \"" + item.type + "\", actual: \"" + partialNode.type + "\"");
                    }
                    return [4 /*yield*/, partialNode];
                case 8:
                    _c.sent();
                    index++;
                    _c.label = 9;
                case 9:
                    partialNodes_1_1 = partialNodes_1.next();
                    return [3 /*break*/, 7];
                case 10: return [3 /*break*/, 13];
                case 11:
                    e_3_1 = _c.sent();
                    e_3 = { error: e_3_1 };
                    return [3 /*break*/, 13];
                case 12:
                    try {
                        if (partialNodes_1_1 && !partialNodes_1_1.done && (_b = partialNodes_1.return)) _b.call(partialNodes_1);
                    }
                    finally { if (e_3) throw e_3.error; }
                    return [7 /*endfinally*/];
                case 13:
                    nodes_2_1 = nodes_2.next();
                    return [3 /*break*/, 5];
                case 14: return [3 /*break*/, 17];
                case 15:
                    e_4_1 = _c.sent();
                    e_4 = { error: e_4_1 };
                    return [3 /*break*/, 17];
                case 16:
                    try {
                        if (nodes_2_1 && !nodes_2_1.done && (_a = nodes_2.return)) _a.call(nodes_2);
                    }
                    finally { if (e_4) throw e_4.error; }
                    return [7 /*endfinally*/];
                case 17: return [2 /*return*/];
            }
        });
    };
    CollectionBuilder.prototype.createNode = function (item) {
        var key = item.key, type = item.type, content = item.content, _a = item.props, props = _a === void 0 ? {} : _a, _b = item.hasChildren, hasChildren = _b === void 0 ? false : _b, children = item.children;
        if (key == null || type == null) {
            return null;
        }
        var builder = this;
        var node = {
            type: type,
            key: key,
            props: props,
            content: content,
            hasChildren: hasChildren,
            children: new CacheableList(function () {
                var index, _a, _b, child, nodes, nodes_3, nodes_3_1, node_1, e_5_1, e_6_1;
                var e_6, _c, e_5, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            if (!children || !hasChildren) {
                                return [2 /*return*/];
                            }
                            index = 0;
                            _e.label = 1;
                        case 1:
                            _e.trys.push([1, 12, 13, 14]);
                            _a = __values(children()), _b = _a.next();
                            _e.label = 2;
                        case 2:
                            if (!!_b.done) return [3 /*break*/, 11];
                            child = _b.value;
                            nodes = builder.getNodes(child, index, node);
                            _e.label = 3;
                        case 3:
                            _e.trys.push([3, 8, 9, 10]);
                            nodes_3 = (e_5 = void 0, __values(nodes)), nodes_3_1 = nodes_3.next();
                            _e.label = 4;
                        case 4:
                            if (!!nodes_3_1.done) return [3 /*break*/, 7];
                            node_1 = nodes_3_1.value;
                            return [4 /*yield*/, node_1];
                        case 5:
                            _e.sent();
                            index++;
                            _e.label = 6;
                        case 6:
                            nodes_3_1 = nodes_3.next();
                            return [3 /*break*/, 4];
                        case 7: return [3 /*break*/, 10];
                        case 8:
                            e_5_1 = _e.sent();
                            e_5 = { error: e_5_1 };
                            return [3 /*break*/, 10];
                        case 9:
                            try {
                                if (nodes_3_1 && !nodes_3_1.done && (_d = nodes_3.return)) _d.call(nodes_3);
                            }
                            finally { if (e_5) throw e_5.error; }
                            return [7 /*endfinally*/];
                        case 10:
                            _b = _a.next();
                            return [3 /*break*/, 2];
                        case 11: return [3 /*break*/, 14];
                        case 12:
                            e_6_1 = _e.sent();
                            e_6 = { error: e_6_1 };
                            return [3 /*break*/, 14];
                        case 13:
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_6) throw e_6.error; }
                            return [7 /*endfinally*/];
                        case 14: return [2 /*return*/];
                    }
                });
            }),
        };
        return node;
    };
    CollectionBuilder.prototype.getCollectionElement = function (item) {
        var element = item.element;
        if (element) {
            if (!isCollectionElement(element)) {
                throw new Error('Unknown element');
            }
            return element;
        }
        return null;
    };
    CollectionBuilder.prototype.getKey = function (element, node, index, parent) {
        if (node.key != null) {
            return node.key;
        }
        if (node.element) {
            return;
        }
        if (element.key != null) {
            return element.key;
        }
        return (parent === null || parent === void 0 ? void 0 : parent.key) ? (parent === null || parent === void 0 ? void 0 : parent.key) + "." + index : "$." + index;
    };
    return CollectionBuilder;
}());
export { CollectionBuilder };
